// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles(() => ({
  container: {
    backgroundColor: 'white',
    paddingVertical: 15,
    width: '100%',
    paddingHorizontal: 20
  },
  content: {
    fontWeight: 'bold',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 10,
    alignItems: 'center'
  },
  mainContainer: {
    width: '100%',
    borderWidth: 0
  },
  title: {
    fontWeight: 'bold',
    marginLeft: 10
  }
}));
